import React, { useState, useRef, useEffect } from 'react';
// import OwlCarousel from 'react-owl-carousel';
import $ from "jquery";



import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

import Header from "../../widgets/Header";
import Footer from "../../widgets/Footer";
import FormModal from "../../widgets/FormModal";

export default function Plan() {

      const [show, setShow] = useState(false);
      const openIframeWindow = () => {
          setShow(!show);
      }
  const options = {
    margin: 20,
    nav: false,
    loop: true,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: false,
    smartSpeed: 1000,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 3,
      },
      1000: {
        items: 4,
      },
    },
  };


useEffect(() => {
    // Dynamically import inside useEffect so it runs in the browser
    const loadOwl = async () => {
      const $ = (await import("jquery")).default;
      window.$ = window.jQuery = $;

      await import("owl.carousel/dist/owl.carousel.min.js");

      const $owl = $(".owl-carousel");

      if (typeof $owl.owlCarousel === "function") {
        $owl.owlCarousel({
          margin: 20,
          nav: false,
          loop: true,
          autoplay: true,
          autoplayTimeout: 3000,
          autoplayHoverPause: false,
          smartSpeed: 1000,
          responsive: {
            0: { items: 1 },
            600: { items: 3 },
            1000: { items: 3 },
          },
        });
      } else {
        console.error("❌ Owl Carousel plugin failed to attach to jQuery");
      }
    };

    loadOwl();

    // optional cleanup
    return () => {
      if (window.$ && $(".owl-carousel").data("owl.carousel")) {
        $(".owl-carousel").trigger("destroy.owl.carousel");
      }
    };
  }, []);

  return (
    <> <section className="light_bg">
      <Header />
      <div className="top_space"></div>

      <section className="ps">
        <div className="container">
          <h1 className="text-center mb-md-5 mb-4 hadding">Don’t know what’s right for you?<br /> Choose what fits you best.</h1>

          <div className="row pt-3">
            <div className="col-md-4 mb-4 mb-md-0">
              <div className="plan_box">
                <div className="plan_top">
                  <img src="/assets/img/pe1.png" alt="pe" class="img-fluid d-block" />
                  <p className="op0_5">Your personalised Genetic report indicating health risk factors</p>
                </div>
                {/* <h3><sup><i className="bi bi-currency-rupee"></i></sup>19,900/-</h3> */}
              </div>
            </div>
            <div className="col-md-4 mb-4 mb-md-0">
              <div className="plan_box">
                <div className="plan_top">
                  <img src="/assets/img/pe2.png" alt="pe" class="img-fluid d-block" />
                  <p className="op0_5">Genetic report +Metabolic analysis + Lifestyle modification blue print +
                    TRIGR app with Health Concierge</p>
                </div>
                {/* <h3><sup><i className="bi bi-currency-rupee"></i></sup>35,400/-</h3> */}
              </div>
            </div>
            <div className="col-md-4 mb-4 mb-md-0">
              <div className="plan_box active">

                <div className="plan_top">
                  <span className="most_popular">Most Popular</span>
                  <img src="/assets/img/pe3.png" alt="pe" class="img-fluid d-block" />
                  <p>The ultimate Lifestyle Modification program where transformation is guaranteed with the
                    support of a Lifestyle Coach</p>
                </div>
                {/* <h3><sup><i className="bi bi-currency-rupee"></i></sup>45,400/-</h3> */}
              </div>
            </div>


          </div>
        </div>
      </section>
      <section className="ps find_program">
        <div className="container  ">
          <div className="text-center">
            <h2 className="hadding mb-3">Find the Program That’s Right for you</h2>
            <p className=" mb-4 mb-md-5">Choose the program that matches your needs and goals. Whether you want
              insights, expert guidance, or a<br /> complete lifestyle transformation, EPLIMO has an option built
              for you.</p>
            
          </div>
          <div className="table-responsive mt-5">
            <table className="table table-dark mb-0 ">
              <thead>
                <tr>
                  <th>Feature / Benefit</th>
                  <th className="text-center"><span style={{marginTop:"6px",marginBottom:"0px",display:"block"}}> EPLIMO BASIC </span>
                   {/* <a href="#" className="btn" style={{padding:"10px 50px"}}>Buy Now</a> */}
                   </th>
                  <th className="text-center"><span style={{marginTop:"6px",marginBottom:"0px",display:"block"}}>EPLIMO ADVANCE </span> 
                   {/* <a href="#" className="btn" style={{padding:"10px 50px"}}>Buy Now</a> */}
                   </th>
                  <th className="color1 text-center" style={{color:"#047D7D"}}> <span style={{marginTop:"6px",marginBottom:"0px",display:"block"}}>EPLIMO PRO </span>
                  {/* <a href="#" className="btn" style={{padding:"10px 50px"}}>Buy Now</a> */}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>DNA Testing</td>
                  <td className="text-center"><i className="bi bi-check-circle-fill color1"></i></td>
                  <td className="text-center"><i className="bi bi-check-circle-fill color1"></i></td>
                  <td className="text-center"><i className="bi bi-check-circle-fill color1"></i></td>
                </tr>
                <tr>
                  <td>Metabolic Testing</td>
                  <td className="text-center"><i className="bi bi-x-circle-fill close_color"></i></td>
                  <td className="text-center"><i className="bi bi-check-circle-fill color1"></i></td>
                  <td className="text-center"><i className="bi bi-check-circle-fill color1"></i></td>
                </tr>
                <tr>
                  <td>Personalized Report in TRIGR App</td>
                  <td className="text-center"><i className="bi bi-x-circle-fill close_color"></i></td>
                  <td className="text-center"><i className="bi bi-check-circle-fill color1"></i></td>
                  <td className="text-center"><i className="bi bi-check-circle-fill color1"></i></td>
                </tr>
                <tr>
                  <td>Health Risk Screening (270+ conditions)</td>
                  <td className="text-center"><i className="bi bi-check-circle-fill color1"></i></td>
                  <td className="text-center"><i className="bi bi-check-circle-fill color1"></i></td>
                  <td className="text-center"><i className="bi bi-check-circle-fill color1"></i></td>
                </tr>
                <tr>
                  <td>1-on-1 Expert Consultation (Doctor / Geneticist)</td>
                  <td className="text-center"><i className="bi bi-x-circle-fill close_color"></i></td>
                  <td className="text-center"><i className="bi bi-check-circle-fill color1"></i></td>
                  <td className="text-center"><i className="bi bi-check-circle-fill color1"></i></td>
                </tr>
                <tr>
                  <td>Personalized Blueprint (diet, fitness, lifestyle plan)</td>
                  <td className="text-center"><i className="bi bi-x-circle-fill close_color"></i></td>
                  <td className="text-center"><i className="bi bi-check-circle-fill color1"></i></td>
                  <td className="text-center"><i className="bi bi-check-circle-fill color1"></i></td>
                </tr>
                <tr>
                  <td>Coaching & Lifestyle Modification Program</td>
                  <td className="text-center"><i className="bi bi-x-circle-fill close_color"></i></td>
                  <td className="text-center"><i className="bi bi-x-circle-fill close_color"></i></td>
                  <td className="text-center"><i className="bi bi-check-circle-fill color1"></i></td>
                </tr>
                <tr>
                  <td>Continuous Support via TRIGR App</td>
                  <td className="text-center"><i className="bi bi-x-circle-fill close_color"></i></td>
                  <td className="text-center"><i className="bi bi-check-circle-fill color1"></i></td>
                  <td className="text-center"><i className="bi bi-check-circle-fill color1"></i></td>
                </tr>
                <tr>
                  <td>Ongoing plan updates </td>
                  <td className="text-center"><i className="bi bi-x-circle-fill close_color"></i></td>
                  <td className="text-center"><i className="bi bi-check-circle-fill color1"></i></td>
                  <td className="text-center"><i className="bi bi-check-circle-fill color1"></i></td>
                </tr>
                <tr>
                  <td>Best For</td>
                  <td className="text-center">Those starting out with DNA insights</td>
                  <td className="text-center">Those who want personalised Lifestyle Modification Plan</td>
                  <td className="text-center">Those ready for a complete health transformation</td>
                </tr>



              </tbody>
            </table>
          </div>

          <div className="runing_man_box position-relative mt-5">
            <img src="/assets/img/plan/runing_man.webp" alt="runing_man" className="runing_man mo_none" />
            <img src="/assets/img/plan/runing_man2.webp" alt="runing_man" className="runing_man pc_none" />
            <div className="row position-relative">
              <div className="col-md-5">
                <h2 className="hadding mb-4">Take the First Step Today</h2>

                <p className=" mb-md-4 mb-3  text-transform-capitalize">Your Path to Peak Health Begins Here
                  one decision today can transform your tomorrow. Don’t wait for symptoms, prevent them.</p>
                <a className="btn" onClick={() => openIframeWindow()}>Join EPLIMO<sup className="sup-font">TM</sup> Program</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className=" ps choose_need">
        <div className="container  ">
          <div className="d-md-flex  align-items-start   justify-content-between mb-4 mb-md-5 text-center text-md-start">
            <div className="">
              <h2 className="hadding mb-3">Choose Only What You Need</h2>
              <h3 className="  mb-4  ">Starting from Rs.9900</h3>
              <p>You also have an option to choose genetic testing for<br /> specific health condition.</p>
             
            </div>
          <a href="#" className="d-inline-flex btn  border-black gap-4 text-black pe-5"> <i className="bi bi-arrow-up-right"></i> Find Out More</a>

          </div>

          <div className="owl-carousel owl-theme">
            <div className="item">
              <div className="choose_need_box">
                <img src="/assets/img/plan/fit-test.webp" alt="fit test" className="w100" />
                <h4>Fit Genome Test</h4>
              </div>
            </div>
            <div className="item">
              <div className="choose_need_box">
                <img src="/assets/img/plan/cardio-test.webp" alt="fit test" className="w100" />
                <h4>Cardio-Metabolic Genome Test</h4>
              </div>
            </div>
            <div className="item">
              <div className="choose_need_box">
                <img src="/assets/img/plan/skin-test.webp" alt="fit test" className="w100" />
                <h4>Skin Genome test</h4>
              </div>
            </div>

            <div className="item">
              <div className="choose_need_box">
                <img src="/assets/img/plan/she-test.webp" alt="fit test" className="w100" />
                <h4>She Genome Test</h4>
              </div>
            </div>
            <div className="item">
              <div className="choose_need_box">
                <img src="/assets/img/plan/auto-test.webp" alt="fit test" className="w100" />
                <h4>Auto Immune Test</h4>
              </div>
            </div>
            <div className="item">
              <div className="choose_need_box">
                <img src="/assets/img/plan/sleep-test.webp" alt="fit test" className="w100" />
                <h4>Sleep Genome Test</h4>
              </div>
            </div>
            <div className="item">
              <div className="choose_need_box">
                <img src="/assets/img/plan/renal-test.webp" alt="fit test" className="w100" />
                <h4>Renal Genome Test</h4>
              </div>
            </div>
            <div className="item">
              <div className="choose_need_box">
                <img src="/assets/img/plan/eye-test.webp" alt="fit test" className="w100" />
                <h4>Ophthalgenome Test</h4>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className="you_ready_sec  position-relative  overflow-hidden">
        <img src="/assets/img/plan/you-ready-bg.webp" alt="cour raddy" className="cour_raddy mo_none" />
        <img src="/assets/img/plan/you-ready-bg2.webp" alt="cour raddy" className="cour_raddy pc_none" />

        <div className="container position-relative">
          <div className="row position-relative">
            <div className="col-md-5  ">
              <h2 className="hadding mb-4    ">Are You Ready to Take Control of Your Future Health?</h2>
              <p className=" mb-md-4 mb-3 ">EPLIMO is more than a health check.  It’s a blueprint for living stronger, longer, and happier. Don’t wait for symptoms to become problems. Take charge today and start living at your peak.</p>
              <a className="btn" onClick={() => openIframeWindow()}>Join EPLIMO<sup className="sup-font">TM</sup> Program</a>
            </div>
          </div>
        </div>
         <FormModal show={show} setShow={setShow} />
      </section>
   
      <Footer /> </section>
    </>
  );
}